let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("76n7a"), load("l253H"), load("kNFvF"), load("3GGfo")]).then(() => parcelRequire('h8XS8'));